<template>
  <div>
    <!-- Table dialog servicios -->
    <el-dialog
      :title="title"
      :visible="isVisible"
      :before-close="handleClose"
      :fullscreen="false"
      top="5vh"
      width="80%"
      center
    >
      <el-row>
        <el-col :span="20" :offset="2" style="width:100%;margin-left:0px">
          <el-card class="box-card">
            <el-table :data="coverages" style="width: 100%" stripe>
              <el-table-column
                label="Cobertura"
                width="111"
                align="center"
                prop="covered"
                sortable
              >
                <template slot-scope="props">
                  <div v-if="props.row.covered">
                    <el-tag
                      class="blob green"
                      size="mini"
                      effect="dark"
                      type="success"
                    >
                      Si
                    </el-tag>
                  </div>
                  <div v-else>
                    <el-tag size="mini" effect="dark" type="danger">
                      No
                    </el-tag>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                property="carrierName"
                label="Paquetería"
                align="center"
                width="140"
                sortable
              >
                <template slot-scope="props">
                  <h4>{{ props.row.service.carrierName }}</h4>
                </template>
              </el-table-column>

              <el-table-column
                property="serviceType"
                label="Servicio"
                align="center"
                width="200"
                sortable
              >
                <template slot-scope="props">
                  <h4>{{ props.row.service.serviceType }}</h4>
                </template>
              </el-table-column>

              <el-table-column
                property="disabled"
                label="Deshabilitado"
                align="center"
                width="140"
                sortable
              >
                <template slot-scope="props">
                  <h4>{{ props.row.disabled || "Ningúno" }}</h4>
                </template>
              </el-table-column>

              <el-table-column
                label="Ocurre"
                align="center"
                width="150"
                prop="isOcurre"
                sortable
              >
                <template slot-scope="props">
                  <div v-if="props.row.isOcurre">
                    <el-tag size="mini" effect="plain" type="warning">
                      Ocurre
                    </el-tag>
                  </div>
                  <div v-else>
                    <el-tag size="mini" effect="dark" type="primary">
                      No
                    </el-tag>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                label="Días de espera"
                align="center"
                prop="updated_at"
                width="180"
                sortable
              >
                <template slot-scope="props">
                  <i class="el-icon-date"></i>
                  {{ props.row.days }} Dias
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- END Table dialog services -->
  </div>
</template>

<script>
export default {
  name: "DialogAddressCoverage",
  components: {},
  props: ["coverages", "isVisible"],
  data() {
    return {
      title: "Coberturas almacenadas por Carrier",
    };
  },
  watch: {
    async isVisible() {},
  },

  methods: {
    handleClose() {
      this.$emit("close");
    },

    update() {
      this.$emit("update");
    },
  },
};
</script>

<style>
.el-select-dropdown__item {
  padding: 10px 20px;
  height: 55px;
  width: 330px;
}
.el-form-item__label {
  font-size: 14px;
  font-weight: 100;
  line-height: 14px;
}
.el-switch__label * {
  line-height: 1;
  font-size: 14px;
  font-weight: 100;
}
.el-input .el-input--small .el-input--suffix {
  width: 260px;
}
</style>
